<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 14 16"
    fill="none"
    style="enable-background:new 0 0 14 16;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_trash">
      <path
        id="Rectangle 1"
        d="M1.11856 3.97317C1.05523 3.38211 1.51842 2.86664 2.11287 2.86664H12.0205C12.6149 2.86664 13.0781 3.38211 13.0148 3.97317L11.9291 14.1065C11.8746 14.6146 11.4458 15 10.9348 15H3.19858C2.68753 15 2.25871 14.6146 2.20427 14.1065L1.11856 3.97317Z"
        stroke-linejoin="round"
      />
      <path id="Vector 35" d="M8.4668 5.66666V12.2" stroke-linecap="round" />
      <path id="Vector 36" d="M5.66675 5.66666V12.2" stroke-linecap="round" />
      <path id="Rectangle 2" d="M9.40006 2.86667V1H4.7334V2.86667" stroke-linejoin="round" />
    </g>
  </svg>
</template>
<style scoped>
.icon-trash {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-trash"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>